__turbopack_context__.v({
  "className": "proximanovaablack_cdfa6c96-module__zVRH9a__className",
});
